import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReferralSummary } from "../../../domain/entities/referral-backoffice";
import { type SummaryParams } from "../../../domain/repos/referrals-backoffice-repo";
import { type ReferralsBackofficeDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getSummary = createAsyncThunk<
  ReferralSummary,
  SummaryParams,
  { dispatch: ReferralsBackofficeDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_SUMMARY, async (params, { extra }) => {
  return await extra.referralsBackofficeRepo.summary(params);
});
